export const marginNoteTop = '10px 0 0 0'
export const interestsMarginTop = '20px 0 0 0'
export const marginTopBottom20 = '20px 0'
export const marginTopBottom1020 = '10px 0 20px 0'
export const fontSize13Number = 13
export const fontSize16 = '16px'
